module.exports = __webpack_public_path__ + "img/about-4-2.946bbbf6.png";